import { memo, useCallback, useMemo } from 'react';

import { OnOffShareToggleRow } from '~/components/ShareModal/components/OnOffShareToggleRow';
import { ToggleInfoTooltip } from '~/components/ShareModal/components/ToggleInfoTooltip';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';

/** Create-mode smart leaf: hide search input toggle. Writes draft state, no per-change analytics. */
export const CreateShowcaseSettingsHideSearchBarRow = memo(() => {
  const { shortUrlProps, isSaving, updateHideSearchBar } = useShowcaseModal();

  const hideSearchBar = useMemo(
    () => shortUrlProps.presentationSettings?.hideSearchBar === true,
    [shortUrlProps.presentationSettings?.hideSearchBar],
  );

  const handleToggleHideSearchBar = useCallback(
    (checked: boolean) => {
      updateHideSearchBar(checked);
    },
    [updateHideSearchBar],
  );

  return (
    <OnOffShareToggleRow
      label="Hide search input"
      labelAccessory={<ToggleInfoTooltip text="Hide the search bar from public viewers" />}
      checked={hideSearchBar}
      isLoading={isSaving}
      onToggle={handleToggleHideSearchBar}
      data-testid="HIDE_SEARCH_BAR_TOGGLE"
    />
  );
});

CreateShowcaseSettingsHideSearchBarRow.displayName = 'CreateShowcaseSettingsHideSearchBarRow';
